import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal'
})
export class UtcToLocalPipe implements PipeTransform {
  transform(date: string | Date, time?: string): string {
    if (!date) {
      return 'N/A'; // Return 'N/A' if date is not provided
    }

    // Combine date and time if both are provided
    let dateTime = new Date(date);
    if (time) {
      dateTime = new Date(`${date}T${time}Z`);
    }

    // Check if the date is valid
    if (isNaN(dateTime.getTime())) {
      return 'Invalid date';
    }

    // Format options for date and time
    const optionsDate: Intl.DateTimeFormatOptions = {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit'
    };

    const optionsTime: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    };

    // Format date and time separately
    const formattedDate = new Intl.DateTimeFormat(undefined, optionsDate).format(dateTime);
    const formattedTime = new Intl.DateTimeFormat(undefined, optionsTime).format(dateTime);

    if (!time) {
      return formattedDate; // Return only the date if no time is provided
    }

    return `${formattedDate} ${formattedTime}`;
  }
}
